import { Box } from '@hopskipdrive/react-components';
import { colorTokens, variables } from '@rideiq/shared/components/variables';
import styled from 'styled-components';

export const ActionContainer = styled(Box)`
  display: flex;
  width: 100%;
  justify-content: space-between;
  .back-button {
    flex: unset;
  }

  .submit-button {
    flex: unset;
    margin-left: auto;
  }

  ${variables.mediaQuery.lessThan('desktop')`
    flex-direction: column;
    gap: 8px;
    padding-bottom: 72px;

    /* Back button goes full-width */
    .back-button {
      width: 100%;
    }

    /* Box wrapping Add manually + Import/Next buttons */
    > .MuiBox-root {
      display: flex;
      flex-direction: column;
      width: 100%;
      margin-left: 0 !important;
      gap: 8px;

      .submit-button {
        width: 100%;
        margin-left: 0;
      }

      /* Add manually button (no dedicated class) */
      > .MuiButtonBase-root {
        width: 100%;
      }
    }
  `}
`;

export const CloseButton = styled('button')`
  display: inline-flex;
  margin-left: auto;
  width: 20px;
  height: 20px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  cursor: pointer;
  border: none;
  background: transparent;
  padding: 0;

  &:hover {
    background: #ddebfa;
    svg {
      color: ${colorTokens.text.hover};
    }
  }

  &:focus-visible {
    outline: 2px solid ${colorTokens.primary.main};
    outline-offset: 2px;
  }
`;

export const MustBeMetLabel = styled.label`
  font-weight: 300;
  font-size: 14px;
  line-height: 20px;
`;
